import { cn } from '@/lib';

interface IProps {
  upperClass?: string;
  lowerClass?: string;
}

export const Stack = ({ upperClass, lowerClass }: IProps) => {
  return (
    <div>
      <div className={cn('h-[25px] w-5 bg-danger', upperClass)} />
      <div className={cn('h-[25px] w-5 bg-olive', lowerClass)} />
    </div>
  );
};
